export const CLASS_NAME = 'cst-net-emissions-chart'
